import { ServicesPopupContext } from '../components/services-popup/providers/ServicesPopupProvider';
import { useContext } from 'react';

const useServicesPopup = () => useContext(ServicesPopupContext);

export default useServicesPopup;
